import { ReportFilterOperation, ReportValue } from '@driftt/api-types'

import { isNilOrEmpty } from 'utils/ramda'

import { filterCreator } from '../query/creators'
import QueryBuilder from '../query/QueryBuilder'

const FILTER_BY_OPTIONS = Object.freeze({
  botStatus: filterCreator('botStatus'),
  goalId: filterCreator('firstRoutingAction.playbookGoalId'),
  relatedPlaybookId: filterCreator('relatedPlaybookId'),
  playbookId: filterCreator('firstRoutingAction.playbookId'),
  routingRuleId: filterCreator('firstRoutingAction.routingRuleId'),
  routingType: filterCreator('firstRoutingAction.type'),
  subType: filterCreator('firstRoutingAction.subType'),
  agentsSelected: filterCreator('firstAgentId', ReportFilterOperation.IN),
  widgetStatus: filterCreator('offline'),
  inboxSelected: filterCreator('inboxId', ReportFilterOperation.IN),
  pageUrl: filterCreator('pageUrl', ReportFilterOperation.CONTAINS),
  classificationId: filterCreator('classificationId'),
})

export const filterForType = (
  filterType: string,
  filterValue: ReportValue | ReportValue[]
) => FILTER_BY_OPTIONS[filterType](filterValue)

export default class ConversationSummaryQueryBuilder extends QueryBuilder {
  constructor(startDate: string, endDate: string, includeDefaultFilter = true) {
    super()

    if (includeDefaultFilter) {
      this.filters.push({
        property: 'firstEndUserMessageAt',
        operation: ReportFilterOperation.BETWEEN,
        values: [startDate, endDate],
      })
    }
  }
  public withFilterType(type, value) {
    if (isNilOrEmpty(value)) {
      return this
    }

    this.filters.push(filterForType(type, value))
    return this
  }
}
